"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";

const ScrollToTop = () => {
    const pathname = usePathname();
    console.log("🚀 ~ ScrollToTop ~ pathname:", pathname);

    useEffect(() => {
        // Scroll to top when route changes (internal link or browser back/forward)
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, [pathname]);

    return null;
};

export default ScrollToTop;
